module.exports = __webpack_public_path__ + "static/img/red.a1357499.png";